
import React from 'react'
import { IconButton, Snackbar, Stack, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
export default function SnackBar({ message = 'Some Message' , open , handleClose }) {
 
    return (
        <Snackbar
            anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
            }}
            open={open}
            autoHideDuration={2000}
            onClose={handleClose}
            message={message}
            action={
                <>
                    <IconButton
                        size="small"
                        aria-label="close"
                        color="inherit"
                        onClick={handleClose}
                    >
                        <CloseIcon fontSize="small" />
                    </IconButton>
                </>
            }
        />
    )
}
